import { PageBreadcrumb } from "./Breadcrumb";
import { PageCard, PAGE_CARD_SCROLL_CONTAINER_ATTR } from "./Card";
import { PageColumn } from "./Column";
import { DefaultPageCard } from "./DefaultPageCard";
import { PageLayout } from "./Layout";
import { PagePaneGroup, usePaneLifecycle } from "./PaneGroup";
import {
  PageRail,
  ResizeHandle,
  useSkipInitialEnterAnimationStyle,
} from "./Rail";
import { PageTitle } from "./Title";
import { PAGE_BOUNDED_ATTR, PAGE_SHELL_ATTR, SHELL_HIDDEN } from "./shell";
import { PAGE_GUTTER, PAGE_GUTTER_X, PAGE_PADDING_TOP } from "./surface";
import { useResizableRailWidth } from "./useResizableRailWidth";

export {
  DefaultPageCard,
  PAGE_CARD_SCROLL_CONTAINER_ATTR,
  PAGE_BOUNDED_ATTR,
  PAGE_GUTTER,
  PAGE_GUTTER_X,
  PAGE_PADDING_TOP,
  PAGE_SHELL_ATTR,
  ResizeHandle,
  SHELL_HIDDEN,
  usePaneLifecycle,
  useResizableRailWidth,
  useSkipInitialEnterAnimationStyle,
};

export const Page = {
  Layout: PageLayout,
  Card: PageCard,
  Breadcrumb: PageBreadcrumb,
  Title: PageTitle,
  Column: PageColumn,
  PaneGroup: PagePaneGroup,
  Rail: PageRail,
};
